import { render, staticRenderFns } from "./ResultCertificate.vue?vue&type=template&id=64a5f8b0"
import script from "./ResultCertificate.vue?vue&type=script&lang=js"
export * from "./ResultCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports